<template>
  <div class="detail-container">
    <h1 class="page-title">業者マスタ情報詳細</h1>
    <div v-if="vendor">
      <table class="table table-bordered">
        <tr>
          <th>ID</th>
          <td>{{ vendor.id }}</td>
        </tr>
        <tr>
          <th>法人番号</th>
          <td>{{ vendor.corp_no }}</td>
        </tr>
        <tr>
          <th>業者名</th>
          <td>{{ vendor.vendor_nm }}</td>
        </tr>
        <tr>
          <th>所在地</th>
          <td>〒{{ vendor.postal_code }} {{vendor.prefecture}}{{vendor.city}}{{vendor.other_address}}</td>
        </tr>
        <tr>
          <th>メールアドレス</th>
          <td>{{ vendor.email }}</td>
        </tr>
        <tr>
          <th>電話番号</th>
          <td>{{ vendor.tel_num }}</td>
        </tr>
        <tr>
          <th>FAX</th>
          <td>{{ vendor.fax }}</td>
        </tr>
      </table>

      <div class="btn-area">
        <router-link :to="{ name: 'VendorList', params: { id: vendor.id }, query: route.query }"> <!-- 業者情報編集ページへのリンク -->
          <button type="button" class="btn btn-primary">一覧へ</button>
        </router-link>

        <router-link v-if="userRole == 0 || userRole == 999" :to="{ name: 'VendorEdit', params: { id: vendor.id }, query: route.query }"> <!-- 業者情報編集ページへのリンク -->
          <button type="button" class="btn btn-success mx-2">編集</button>
        </router-link>
      </div>
    </div>
    <!-- その他の詳細情報 -->
    <div v-else>
      業者情報情報を読み込み中...
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { getVendor } from '@/api/axios';

export default {
  setup() {
    const title = ref('業者情報詳細');

    watchEffect(() => {
      document.title = title.value;
    });

    const store = useStore();
    const route = useRoute();
    const userRole = computed(() => store.state.userRole);
    const vendor = ref({});
    const vendorId = route.params.id;

    const fetchVendor = async () => {
      const response = await getVendor(vendorId);
      vendor.value = response.data;
    };

    onMounted(fetchVendor);

    return {
      title,
      userRole,
      vendor,
      route
    };
  }
};
</script>
